import React from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";

// Pages
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import DashboardPage from "./pages/DashboardPage";
import ShipmentsListPage from "./pages/ShipmentsListPage";
import CreateShipmentPage from "./pages/CreateShipmentPage";
import ShipmentDetailPage from "./pages/ShipmentDetailPage";
import VendorPortalPage from "./pages/VendorPortalPage";
import SuppliersPage from "./pages/SuppliersPage";
import SupplierDetailPage from "./pages/SupplierDetailPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import ComingSoonBilling from './pages/ComingSoonBilling';

// Protected Route Component
function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-importdocs-bg flex items-center justify-center">
        <div className="spinner" />
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
}

// Public Route Component (redirects to dashboard if logged in)
function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-importdocs-bg flex items-center justify-center">
        <div className="spinner" />
      </div>
    );
  }
  
  if (user) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={
        <PublicRoute>
          <LoginPage />
        </PublicRoute>
      } />
      <Route path="/signup" element={
        <PublicRoute>
          <SignupPage />
        </PublicRoute>
      } />

      <Route path="/comingsoon" element={
        <PublicRoute>
          <ComingSoonBilling />
        </PublicRoute>
      } />
      
      {/* Vendor Portal (Public, no auth) */}
      <Route path="/vendor/:token" element={<VendorPortalPage />} />
      
      {/* Protected Routes */}
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <DashboardPage />
        </ProtectedRoute>
      } />
      <Route path="/dashboard/shipments" element={
        <ProtectedRoute>
          <ShipmentsListPage />
        </ProtectedRoute>
      } />
      <Route path="/dashboard/shipments/new" element={
        <ProtectedRoute>
          <CreateShipmentPage />
        </ProtectedRoute>
      } />
      <Route path="/dashboard/shipments/:id" element={
        <ProtectedRoute>
          <ShipmentDetailPage />
        </ProtectedRoute>
      } />
      <Route path="/dashboard/suppliers" element={
        <ProtectedRoute>
          <SuppliersPage />
        </ProtectedRoute>
      } />
      <Route path="/dashboard/suppliers/:id" element={
        <ProtectedRoute>
          <SupplierDetailPage />
        </ProtectedRoute>
      } />
      
      {/* Admin Routes (no link from landing page) */}
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/admin/dashboard" element={<AdminDashboardPage />} />

      <Route path='/Terms' element={<Terms />} />
      <Route path='/Privacy' element={<Privacy />} />
      
      
      {/* Catch all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
